// Workspace logo upload (SPO-1532). The API returns a presigned S3 POST: the
// file goes to S3 as a form, then the API confirms it.

export const MAX_LOGO_BYTES = 10 * 1024 * 1024;

export const ALLOWED_LOGO_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
];

// Why a file can't be used as a logo: "type", "size", or null if it's fine.
export const logoFileProblem = (file, maxBytes = MAX_LOGO_BYTES) => {
  if (!ALLOWED_LOGO_TYPES.includes(file.type)) return "type";
  if (file.size > maxBytes) return "size";
  return null;
};

// The form S3 expects: every policy field first, the file last.
export const logoUploadForm = (fields, file) => {
  const form = new FormData();
  Object.entries(fields || {}).forEach(([name, value]) =>
    form.append(name, value)
  );
  form.append("file", file);
  return form;
};
